"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponQuery = exports.CouponUpdate = exports.CouponCreate = exports.CouponPublicTransport = exports.CouponTransport = exports.CouponTypeLabels = exports.CouponType = exports.CouponTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.CouponTypes = ['PERCENTAGE', 'FIXED'];
exports.CouponType = typebox_1.Type.Union(exports.CouponTypes.map((amount) => typebox_1.Type.Literal(amount)));
/**
 * Object mapping Coupon statuses to their corresponding labels.
 */
exports.CouponTypeLabels = {
    PERCENTAGE: 'Percentage',
    FIXED: 'Fixed',
};
exports.CouponTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    code: typebox_1.Type.String({ description: 'Coupon code', minLength: 1 }),
    type: exports.CouponType,
    discountAmount: typebox_1.Type.Integer({ minimum: 0, description: 'Discount amount in cents or basis points' }),
    expiresAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    metadata: common_1.MetaData,
});
exports.CouponPublicTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    code: typebox_1.Type.String(),
    type: exports.CouponType,
    discountAmount: typebox_1.Type.Integer(),
    expiresAt: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' })),
});
exports.CouponCreate = typebox_1.Type.Omit(exports.CouponTransport, ['id', 'metadata']);
exports.CouponUpdate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CouponCreate, ['code', 'expiresAt']),
    typebox_1.Type.Object({ expiresAt: (0, common_1.Nullable)(typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' }))) }),
]);
exports.CouponQuery = typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({ code: typebox_1.Type.Optional(typebox_1.Type.String({ minLength: 1 })), expired: typebox_1.Type.Optional(typebox_1.Type.Boolean()) }),
]);
//# sourceMappingURL=coupon.js.map